<template>
	<dv-border-box-12 class="lineBox">
		<div class="box">
			<div class="box_title">有效发明专利IPC分类</div>
			<div class="classifyList">
				<div class="classItem_left">
					<div class="sortList">
						<div class="sortItem" v-for="(item,index) in ipcList" :key="index">
							<img :src="item.icon">
							<div class="sort_label">
								<div class="title">{{item.title}}</div>
								<div class="num">
									<countTo :startVal='0' :endVal='Number(item.total)' :duration='800'></countTo>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="classItem_right">
					<div id="radarChart" :style="{ width: '100%', height: '100%' }"></div>
				</div>
			</div>
		</div>
	</dv-border-box-12>
</template>

<script>
	export default {
		data(){
			return{
				ipcList:[],
			}
		},
		mounted() {},
		methods:{
			getData(data){
				this.ipcList = [
					{
						icon:require('@/assets/patent/sort-1.png'),
						title:'人类生活必需',
						total:data.zl_ipc_a,
					}, {
						icon:require('@/assets/patent/sort-2.png'),
						title:'固定建筑物',
						total:data.zl_ipc_e,
					}, {
						icon:require('@/assets/patent/sort-3.png'),
						title:'作业、运输',
						total:data.zl_ipc_b,
					}, {
						icon:require('@/assets/patent/sort-4.png'),
						title:'物理',
						total:data.zl_ipc_g,
					}, {
						icon:require('@/assets/patent/sort-5.png'),
						title:'化学、冶金',
						total:data.zl_ipc_c,
					}, {
						icon:require('@/assets/patent/sort-6.png'),
						title:'电学',
						total:data.zl_ipc_h,
					}, {
						icon:require('@/assets/patent/sort-7.png'),
						title:'机械工程、照明、加热、武器、爆破',
						total:data.zl_ipc_f,
					}, {
						icon:require('@/assets/patent/sort-8.png'),
						title:'纺织、造纸',
						total:data.zl_ipc_d,
					}
				]
				this.drawLine(data);
			},
			// 雷达图
			drawLine(data) {
				var option = {
					radar: {
						shape: 'circle', // 雷达图绘制类型
						center: ['45%', '50%'],
						radius: '70%',
						splitNumber: 1, //()这里是圆的环数)指示器轴的分割段数
						// 雷达图每个指示器名称的配置项
						name: {
							textStyle: {
								color: 'rgba(255, 255, 255, 0.7)',
								fontSize: '12',
								padding: [-10, -12]
							}
						},
						// 分隔区域配置项
						splitArea: {
							show: false,
							areaStyle: {
								color: ['transparent'],
							},
						},
						// 分割线
						splitLine: {
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.8)',
							},
						},
						// 坐标轴轴线相关设置
						axisLine: {
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.3)',
								type: 'dashed',
							},
						},
						// 指示器
						indicator: [
							{
								name: "电学",
								max:60000
							},{
								name: "作业、运输",
								max:60000
							},{
								name: "物理",
								max:60000
							},{
								name: "人类生活必需",
								max:60000
							},{
								name: "机械工程照明加热武器爆破",
								max:60000
							},{
								name: "化学、冶金",
								max:60000
							}, {
								name: "固定建筑物",
								max:60000
							}, {
								name: "纺织、造纸",
								max:60000
							},
						],
					},
					series: [{
						type: 'radar',
						// 折线拐点标志样式
						itemStyle: {
							color: '#FFFF00'
						},
						// 线条样式
						lineStyle: {
							color: '#FFFF00'
						},
						// 区域填充样式
						areaStyle: {
							color: 'rgba(255,255,0,0.4)',
						},
						data: [{
							value: [data.zl_ipc_h,data.zl_ipc_b,data.zl_ipc_g,data.zl_ipc_a,data.zl_ipc_f,data.zl_ipc_c,data.zl_ipc_e,data.zl_ipc_d]
						}]
					}],
				};
				let myChart = this.$echarts.init(document.getElementById('radarChart'));				
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
		}
	}
</script>

<style>
</style>